import {GlobalEvent} from "../../react/global-event";

export const GlobalKeyDown2 = ({action, check, useCapture=false}) => GlobalEvent({
    eventName: "keydown",
    useCapture,
    action: (e) => check(e) && action(e),
});
